import React from 'react';
import { inject } from 'mobx-react';

import { SectionLayout, SectionRowLayout } from 'layouts/section';
import { BannerCardComponent as BannerCard } from 'components/cards';
import { ImageComponent as Image } from 'components/image';
import { CardBackgroundComponent as Card } from 'components/cards';
import { TestimonialComponent as Testimonial } from 'components/cards';
import { QuoteComponent as Quote } from 'components/quote';
import { ContactCardComponent as ContactCard } from 'components/cards';

import portrait from 'static/images/anna-portrait-250x250.png';
import bannerBackground from 'static/images/playing-cats.jpg';
import aboutMeBackground from 'static/images/dogs-on-pasture.jpg';
import testimonialBackground from 'static/images/horses.jpg';
import reginaKorth from 'static/avatars/regina-korth.jpg';
import anjaFritzemeier from 'static/avatars/anja-fritzemeier.jpg';
import lisaLe from 'static/avatars/lisa-le.jpg';
import andreaVuellings from 'static/avatars/andrea-vuellings.jpg';
import anneRitter from 'static/avatars/anne-ritter.jpg';
import sirkaSander from 'static/avatars/sirka-sander.jpg';

const styles = require('./home-page.styles.scss');


@inject('analyticsStore', 'configStore')
export class HomePage extends React.Component {
  componentDidMount() {
    this.props.analyticsStore.pageview('/');
  }

  render() {
    return (
      <div className={styles.HomePage}>
        <SectionLayout wide={true} className={styles.Banner} background={bannerBackground}>
          <h1>
            <span className={styles.HiddenMobile}>
              { 'Dr. Ann-Kathrin Fritsche - ' }
            </span>
            Mobile Tierverhaltenspraxis</h1>
          <p>
            Therapeutin für Tierverhalten in Berlin und Umland. Ich mache individuelle Therapien mit Ihrem Tier, biete aber auch Seminare an, die Ihnen helfen besser mit Ihrem Tier umgehen zu können. Rufen Sie mich an, ich komme zu Ihnen!
          </p>
          <BannerCard />
        </SectionLayout>

        <SectionLayout>
          <h2>Meine Philosopie</h2>
          <p>
            Genau wie wir Menschen haben Tiere einen Charakter und können lernen. Es ist meine Philosophie den Tieren beim Umlernen ihrer Verhaltensweisen genausoviel Respekt entgegenzubringen, wie ich es bei einem Menschen würde.
          </p>

          <Quote author='Victor Hugo'>
            Sieh deinem Hund in die Augen und versuche zu sagen, dass Tiere keine Seele haben.
          </Quote>
          <p>
            Tiere haben eine wichtige Bedeutung in meinem Leben ebenso wie für viele andere Menschen. Wir wünschen uns ein harmonisches Miteinander und dabei sollten die Bedürfnisse von Mensch und Tier beachtet werden. Als Tierärztin habe ich auch körperliche Ursachen für Verhaltensstörungen im Blick und arbeite eng mit Ihrem Haustierarzt zusammen. In der Verhaltenstherapie arbeite ich positiv bestärkend, bei schwierigen Patienten kann eine zusätzliche medikamentelle Unterstützung der Therapie hilfreich sein.
          </p>

          <Quote author='Heinz Rühmann'>
            Natürlich kann man ohne Hund leben. Es lohnt sich nur nicht.
          </Quote>

          <p>
            Wichtig ist mir das Verstehen von unterschiedlichen Kommunikationsformen. Menschen kommunizieren primär über ihre Stimme, Tiere über körperliches Ausdrucksverhalten und subtile Signale. In meinen Beratungsgesprächen analysiere ich das problematische Verhalten des Tieres und erkläre etwaige Missverständnisse zwischen Halter und Tier. Ich biete im Gespräch verschiedene Lösungswege an. Auch Grenzen müssen definiert und klar kommuniziert werden. Gemeinsam wird der sinnvollste Therapieansatz und Regeln für das jeweilige Mensch-Tier-Team besprochen und geübt.
          </p>

          <Quote author='Francesco Petrarca (1304 - 1374)'>
            Die Menschheit lässt sich grob in zwei Gruppen einteilen: In Katzenliebhaber und in vom Leben Benachteiligte.
          </Quote>
        </SectionLayout>

        <SectionLayout background={aboutMeBackground}>
          <Card className={styles.AboutMeCard}>
          <Image
            className={styles.Portrait}
            src={portrait}
            width={250}
            round={true}
            border={true}
            alt='portrait' />

          <h2>Über mich</h2>

            <p>
              Ich, Dr. Ann-Kathrin Fritsche, habe in Berlin Tiermedizin studiert. Nach meinem Abschluss 2008 arbeitete ich parallel für meine Doktorarbeit im Labor (Herpesvirus beim Pferd) und als Assistentin in einer Kleintierpraxis im Berliner Umland. In Not- und Wochenenddiensten habe ich viele unterschiedliche Fälle gesehen und behandelt. Nach 3 Jahren wechselte ich in eine Kleintierpraxis in Brandenburg. In der Sprechstunde sind bei Hunden und Katzen neben körperlichen Problemen in den letzten Jahren mehr und mehr seelische Störungen thematisiert worden.
            </p>
            <p>
              Privat war ich lange mit meiner Hündin Wilma in einer Rettungshundestaffel einer deutschen Hilfsorganisation aktiv. Hier habe ich viel über Ausdrucksverhalten und Hundetraining gelernt. Ich fing an mich gezielt auf dem Gebiet der Tierverhaltensmedizin fortzubilden. Von 2013 bis 2014 besuchte ich die Module 1 – 8 zu verschiedenen Themen der Tierverhaltenstherapie von der Akademie für tierärztliche Fortbildung (ATF) in Hannover. In den darauffolgenden Jahren schlossen sich weitere Fortbildungen an.
            </p>

            <p>
              Ich bin sehr froh mein privates Interresse an Tierverhalten auch beruflich umzusetzen. Denn mit meinem tierärztlichen Wissen und der praktischen Erfahrung im Tiertraining kann ich Ihnen und Ihrem Tier helfen.
            </p>
          </Card>
        </SectionLayout>

        <SectionLayout>
          <h2>Kontakt</h2>
          <p>
            Gerne helfe ich Ihnen und Ihrem Tier. Hilfreich ist eine Schilderung des problematische Verhalten des Patienten, die Umstände und die Krankengeschichte. Dafür sende ich Ihnen den entsprechenden Fragebogen zu und zeitnah wird der erste Hausbesuch verabredet.
          </p>

          <p>
            Hier können Sie mich erreichen um einen Termin zu vereinbaren oder ein Seminar zu buchen:
          </p>

          <ContactCard
            tel='+49-174-3595658'
            email='kontakt@tierverhalten.berlin'
            links={this.props.configStore.links$}
          />
        </SectionLayout>

        <SectionLayout wide={true} background={testimonialBackground}>
          <SectionRowLayout>
           <div className={styles.TestimonialContainer}>
              <Testimonial
                avatar={reginaKorth}
                name='Dr. Regina Korth'
                rating={5}
                date='15.03.2017'
              >
                Kann Frau Dr. Fritsche als gewissenhafte Kollegin nur wärmstens empfehlen!
              </Testimonial>
           </div>

            <div className={styles.TestimonialContainer}>
              <Testimonial
                avatar={anjaFritzemeier}
                name='Anja Fritzemeier'
                rating={5}
                date='01.02.2017'
              >
                Ich fühle mich sehr gut beraten und es werden meine Sorgen und Nöte ernst genommen.
              </Testimonial>
           </div>
          </SectionRowLayout>

          <SectionRowLayout>
            <div className={styles.TestimonialContainer}>
              <Testimonial
                avatar={lisaLe}
                name='Lisa Le'
                rating={5}
                date='20.01.2017'
              >
               Frau Dr. Fritsche ist Tierärztin und Verhaltenstrainerin. Eine super Kombi, da man sich sicher sein kann, dass Verhaltensprobleme auch von medizinischer Seite beleuchtet werden.
              </Testimonial>
            </div>

            <div className={styles.TestimonialContainer}>
              <Testimonial
                avatar={andreaVuellings}
                name='Andrea Vüllings'
                rating={5}
                date='20.07.2017'
              >
                Das Seminar selbst war sehr gut vorbereitet, verständlich und die Geschichten aus der Tierarztpraxis und Verhaltenstherapie haben alles nochmal abgerundet. Vielen lieben Dank!
              </Testimonial>
            </div>
          </SectionRowLayout>

      <SectionRowLayout>
            <div className={styles.TestimonialContainer}>
              <Testimonial
                avatar={anneRitter}
                name='Anne Ritter'
                rating={5}
                date='20.08.2017'
              >
                Frau Dr. Fritsche hat auch ein sehr gutes Einfühlungsvermögen in die Vierbeiner, das hat mir extrem gut gefallen!
              </Testimonial>
            </div>

            <div className={styles.TestimonialContainer}>
              <Testimonial
                avatar={sirkaSander}
                name='Sirka Sander'
                rating={5}
                date='17.08.2017'
              >
                Ich habe gestern an Fr. Dr. Fritsches Erste-Hilfe-Kurs für Hundehalter teilgenommen und war begeistert: alle wichtigen Informationen, kurz, prägnant und trotzdem ausführlich genug.
              </Testimonial>
            </div>
          </SectionRowLayout>
        </SectionLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.page.jsx